// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { HashCodeScoreGenerator } from './HashCodeScoreGenerator';
import { ContextTagKeys } from '@microsoft/applicationinsights-common';

var SamplingScoreGenerator =
/** @class */
function () {
  function SamplingScoreGenerator() {
    this.hashCodeGeneragor = new HashCodeScoreGenerator();
  }

  SamplingScoreGenerator.prototype.getSamplingScore = function (envelope) {
    var tagKeys = new ContextTagKeys();
    var score = 0;

    if (envelope.tags[tagKeys.userId]) {
      score = this.hashCodeGeneragor.getHashCodeScore(envelope.tags[tagKeys.userId]);
    } else if (envelope.tags[tagKeys.operationId]) {
      score = this.hashCodeGeneragor.getHashCodeScore(envelope.tags[tagKeys.operationId]);
    } else {
      // tslint:disable-next-line:insecure-random
      score = Math.random();
    }

    return score;
  };

  return SamplingScoreGenerator;
}();

export { SamplingScoreGenerator };